import { Stack, xcss } from '@atlaskit/primitives';
import React from 'react';
import { SidebarOption } from './SidebarOption';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const sidebarWrapperStyles = xcss({
  borderRightWidth: 'border.width',
  borderRightColor: 'color.border',
  borderRightStyle: 'solid',
  height: '100%',
  maxWidth: '50%',
  // Prevent the sidebar from growing larger than 50% of the screen, in case of long sidebar option names
  overflow: 'auto'
});
export const Sidebar = _ref => {
  let {
    filterDefinitions,
    selectedSidebarOptionId,
    selectedOptions,
    onSidebarOptionClick,
    enableSort = false,
    enableAppification = false
  } = _ref;
  return /*#__PURE__*/_jsxs(Stack, {
    role: "tablist",
    xcss: sidebarWrapperStyles,
    children: [enableSort && /*#__PURE__*/_jsx(SidebarOption, {
      id: "sort-by",
      label: "Sort by",
      isSelected: selectedSidebarOptionId === 'sort-by',
      numberOfSelections: 0,
      onClick: onSidebarOptionClick
    }), filterDefinitions.map(filterDefinition => {
      var _selectedOptions$filt, _selectedOptions$filt2;
      const filterLabel = enableAppification && filterDefinition.label === 'Product' ? 'Works with' : filterDefinition.label;
      return /*#__PURE__*/_jsx(SidebarOption, {
        id: filterDefinition.filterId,
        label: filterLabel,
        isSelected: filterDefinition.filterId === selectedSidebarOptionId,
        numberOfSelections: (_selectedOptions$filt = selectedOptions === null || selectedOptions === void 0 ? void 0 : (_selectedOptions$filt2 = selectedOptions[filterDefinition.filterId]) === null || _selectedOptions$filt2 === void 0 ? void 0 : _selectedOptions$filt2.length) !== null && _selectedOptions$filt !== void 0 ? _selectedOptions$filt : 0,
        onClick: onSidebarOptionClick
      }, filterDefinition.filterId);
    })]
  });
};